<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Journey Offer Categories</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9">
            <div class="isotope-wrapper">
              <div class="row">
                <div class="box_general padding_bottom">
                  <div :disabled="loader">
                  </div>
                    <div
                      class="form-group"
                      v-for="cat in categories"
                      :key="cat.id"
                    >
                      <h5>
                        <input
                          type="checkbox"
                          :id="'parent_check_' + cat.id"
                          @click="checkChild(cat.id)"
                          v-model="parentCheck"
                          :value="cat.id"
                        /><label
                          class="form-check-label parentCat"
                          :for="'parent_check_' + cat.id"
                          >{{ cat.category }}</label
                        >
                      </h5>

                      <div
                        v-for="ch in cat.child"
                        :key="ch.id"
                        class="form-check food"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :value="ch.id"
                          v-model="tag_id"
                          @click="uncheckParent(ch.id, cat.id)"
                          :id="'check_' + ch.id"
                          :class="'childcat parent_check_' + cat.id"
                          :true-value="ch.id"
                          false-value=""
                        />
                        <label
                          class="form-check-label"
                          :for="'check_' + ch.id"
                          >{{ ch.category }}</label
                        >
                      </div>
                    </div>

                    <div id="pass-info" class="clearfix"></div>
                    <div class="form-group" :disabled="loading">
                      <span
                        v-show="loading"
                        class="spinner-border spinner-border-sm"
                      ></span>

                      <button
                        type="button"
                        class="btn_1 rounded add_top_30"
                        @click="createJourneyCategories('destination')"
                        :disabled="loading"
                      >
                        Add destinations</button
                      >&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn_1 rounded add_top_30 purchase btn-success"
                        @click="createJourneyCategories('finish')"
                        :disabled="loading"
                      >
                        Finish Journey
                      </button>
                    </div>
                </div>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "@/services/index.js";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import $ from "jquery";
export default {
  data() {
    return {
      categories: [],
      areaofinterest: [],
      tag_id: [],
      msg: null,
      classAlert: null,
      loading: false,
      loader: false,
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
  beforeMount() {
    this.checkToken();
    this.getParentservices();
    this.getAreaofinterest();
  },
  // watch: {
  //   tag_id: {
  //     handler: function (newValue, oldVal) {
  //       alert(newValue + " " + oldVal);
  //     },
  //     deep: true,

  //     // new additional array value will be here every time any checkbox switched
  //   },
  // },
  computed: {
    parentCheck: {
      get: function () {
        return this.categories
          ? this.tag_id.length == this.categories.length
          : false;
      },
      set: function (value) {
        //alert("hii");
        var selected = [];

        if (value) {
          this.categories.forEach(function (cat) {
            cat.child.forEach(function (child) {
              if ($("#check_" + child.id).is(":checked")) {
                //alert("#check_" + child.id);
                selected.push(child.id);
              }
            });
            if ($("#parent_check_" + cat.id).is(":checked")) {
              //alert(cat.id + " checked");
            } else {
              //alert(cat.id + " unchecked");
              $("#parent_check_" + cat.id).prop("checked", false);
            }
          });
        }

        this.tag_id = selected;
      },
    },
  },
  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },

    checkChild(parentId) {
      $(".parent_check_" + parentId).prop("checked", false);
      if ($("#parent_check_" + parentId).is(":checked") == true) {
        $(".parent_check_" + parentId).prop("checked", true);
      }
    },
    uncheckParent(id, parentId) {
      //alert($(".parent_check_" + parentId).length);
      if ($("#check_" + id).is(":checked") == true) {
        if (
          $(".parent_check_" + parentId).length ==
          $("input:checkbox.parent_check_" + parentId + ":checked").length
        ) {
          $("#parent_check_" + parentId).prop("checked", true);
        }
      } else {
        $("#parent_check_" + parentId).prop("checked", false);
      }
    },
    getParentservices() {
      this.loader = true;
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);

      API.get("categories/parent_services", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.loader = false;
          this.categories = res.data.data;
          console.log(this.categories);
        })
        .catch((err) => {
          this.loader = false;
          this.$swal("Error", err.response);
          console.log(err.response);
        });
    },

    createJourneyCategories(type) {
      this.loading = true;
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      //alert(this.tag_id);
      if (this.tag_id == "") {
        Toast.fire({
          icon: "Error",
          title: "please select atleast 1 category",
        });
        this.loading = false;

        return false;
      }

      const form = new FormData();
      let id = this.$router.currentRoute.params.id;
      console.log(id)
      form.append("tag_id", this.tag_id);
      form.append("user_journey_id", id);
      const token = "Bearer " + localStorage.getItem("token");
      API.post("/userjourney/create_journey_categories", form, {
        headers: { Authorization: token },
      }).then((res) => {
        console.log(res.data);
        this.loading = false;
        if (res.data.status == 200) {
          this.$swal("Success", res.data.messages);
        } else {
          this.$swal("Error", res.data.messages);
        }

        if (type == "finish") {
          this.$router.push("/my-journey");
        } else {
          this.$router.push("/add-destination-list/" + id);
        }
      });
      //axios
    },

    getAreaofinterest() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(token);
      API.get(
        "userjourney/get_journey_categories/" +
          this.$router.currentRoute.params.id,
        {
          headers: { Authorization: token },
        }
      )
        .then((res) => {
          if (res.data.data.length > 0) {
            this.areaofinterest = res.data.data;
            res.data.data.forEach((value) => {
              this.tag_id.push(value.category_id);
            });
          } else {
            API.get("profile/get_Area_of_interest", {
              headers: { Authorization: token },
            })
              .then((res) => {
                this.areaofinterest = res.data.data;
                res.data.data.forEach((value) => {
                  this.tag_id.push(value.tag_id);
                });
              })
              .catch((err) => {
                console.log(err.response);
              });
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
  },
};
</script>

<style  scoped>
.form-group {
  width: 100%;
  position: relative;
  margin: 10px 8px;
  float: left;
}
.form-check.food {
  width: 48%;
  margin: 0 8px;
  float: left;
}
.form-check.merchandise {
  width: 30%;
  margin: 0 8px;
  float: left;
}
.form-check.services {
  width: 30%;
  margin: 0 8px;
  float: left;
}
.form-check-input {
  margin: 5px 0;
}
.form-check-label {
  margin-left: 20px;
  margin-top: 0;
}
figure h2 {
  position: relative;
  top: 30px;
}
a.btn_1.full-width,
.btn_1.full-width {
  width: unset !important;
  display: unset !important;
  border-radius: 15px !important;
  padding: 8px 20px;
}
.box_general {
  padding: 25px !important;
}
</style>